import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import ReactDatePicker, { setDefaultLocale } from "react-datepicker";
import tr from "date-fns/locale/tr";
import moment from "moment";
import { setNotification } from "../../helpers/notification";
import { LANG_VALUES } from "../../helpers/convert";
export default function Input(props) {
  let {
    type,
    label,
    suffixIcon,
    onChange,
    acceptDecimal,
    error,
    placeholder,
    placement,
    name,
    value,
    disabled,
    ...args
  } = props;

  useEffect(() => {
    setDefaultLocale(tr);
  }, []);
  let language = window.localStorage.getItem("i18nextLng");
  const change = (e) => {
    if (type === "number" && (args.max || args.min)) {
      // silinmeye çalışılıyorsa kontrolü
      if (e.target.value !== "") {
        if (e.target.value === "0" && args.min) {
          e.target.value = args.min;
          onChange(e);
          return;
        }
        if (args.max && e.target.value > args.max) {
          e.target.value = args.max;
          onChange(e);
          return;
        }
      }
    }
    onChange(e);
  };

  const validate = (e) => {
    if (type === "number" && args.min) {
      // silinmeye çalışılıyorsa kontrolü
      if (e.target.value !== "") {
        if (e.target.value < args.min && e.target.value !== "0") {
          e.target.value = args.min;
          if ([LANG_VALUES.TR,LANG_VALUES.TRL].includes(language)) {
            setNotification(
              "error",
              `${label ? label + " için " : ""}Minimum ${
                args.min
              } girebilirsiniz.`
            );
          } else {
            setNotification(
              "error",
              `${label ? label + " must be " : ""}Minimum ${args.min}TL.`
            );
          }

          onChange(e);
          return;
        }
      }
    }
  };
  const validateKeyDown = (e) => {
    if (type === "number" && (args.min || args.max)) {
      if (!acceptDecimal) {
        if (
          !(e.which >= 48 && e.which <= 57) &&
          !(e.which >= 96 && e.which <= 105) &&
          e.which !== 8 &&
          e.which !== 37 &&
          e.which !== 39
        ) {
          // 48-57 for 0-9 numbers
          // 96-105 for 0-9 numpad numbers
          // 37-39 for forward and backward buttons
          // 8 for backspace
          e.preventDefault();
        }
      } else {
        if (
          !(e.which >= 48 && e.which <= 57) &&
          !(e.which >= 96 && e.which <= 105) &&
          e.which !== 8 &&
          e.which !== 190 &&
          e.which !== 37 &&
          e.which !== 39
        ) {
          // 48-57 for 0-9 numbers
          // 96-105 for 0-9 numpad numbers
          // 37-39 for forward and backward buttons
          // 190 for dot
          // 8 for backspace
          e.preventDefault();
        }
      }
    }
  };

  const validateMaxLength = (e) => {
    if (args.maxLength)
      if (e.target.value.length > e.target.maxLength)
        e.target.value = e.target.value.slice(0, e.target.maxLength);
  };

  const datepickerChange = (date) => {
    let e;
    if (!date) {
      e = {
        target: {
          name: name,
          value: "",
        },
      };
      onChange(e);
      return;
    }
    if (type === "month") {
      e = {
        target: {
          name: name,
          value: moment(date).format("YYYY-MM"),
        },
      };
      onChange(e);
      return;
    }
    if (type === "date") {
      e = {
        target: {
          name: name,
          value: date,
        },
      };
      onChange(e);
      return;
    }
    if (type === "time") {
      e = {
        target: {
          name: name,
          value: moment(date).format("HH:mm"),
        },
      };
      onChange(e);
      return;
    }
  };
  const datepickerLanguage = () => {
    return window.localStorage.i18nextLng;
  };

  const datePickerPosition = (placement) => {
    return placement;
  };
  const datepickerValue = (v) => {
    if (!v) {
      return null;
    }
    if (type === "month") {
      let date = moment(v, "YYYY-MM").toString();
      return new Date(date);
    }
    if (type === "date") {
      let date = moment(v).format("YYYY-MM-DD");
      return new Date(date);
    }
    if (type === "time") {
      let date = moment(v, "HH:mm").toString();
      return new Date(date);
    }
  };
  const datepickerMinDate = () => {
    if (!args.min) {
      return null;
    }
    if (type === "month") {
      let date = moment(args.min, "YYYY-MM").toString();
      return new Date(date);
    }
    if (type === "date") {
      let date = moment(args.min).toString();
      return new Date(date);
    }
  };
  const datepickerMaxDate = () => {
    if (!args.max) {
      return null;
    }
    if (type === "month") {
      let date = moment(args.max, "YYYY-MM").toString();
      return new Date(date);
    }
    if (type === "date") {
      let date = moment(args.max).toString();
      return new Date(date);
    }
  };
  const removeDatePickerValue = () => {
    if (!disabled) {
      let e = {
        target: {
          name: name,
          value: "",
        },
      };
      onChange(e);
    }
  };
  const popperPlacementPositions = [
    "auto",
    "auto-left",
    "auto-right",
    "bottom",
    "bottom-end",
    "bottom-start",
    "left",
    "left-end",
    "left-start",
    "right",
    "right-end",
    "right-start",
    "top",
    "top-end",
    "top-start",
  ];

  return (
    <div className="km__c--input-container">
      {label ? <label>{label}</label> : null}
      {type !== "month" && type !== "date" && type !== "time" && (
        <input
          className={`km__c--input ${
            suffixIcon ? "km__c--input-has-icon" : ""
          } ${error ? "km__c--input-has-error" : ""}`}
          type={type === "number" ? "text" : type}
          onChange={change}
          onBlur={validate}
          onKeyDown={validateKeyDown}
          onInput={validateMaxLength}
          placeholder={placeholder}
          name={name}
          value={value}
          disabled={disabled}
          autoComplete="off"
          {...args}
        />
      )}
      {type === "month" && (
        <ReactDatePicker
          showMonthDropdown
          showMonthYearPicker
          dateFormat="MMMM yyyy"
          placeholderText={placeholder}
          onChange={datepickerChange}
          selected={datepickerValue(value)}
          minDate={datepickerMinDate()}
          maxDate={datepickerMaxDate()}
          disabled={disabled}
          id={args.id ? args.id : null}
          locale={datepickerLanguage()}
          popperPlacement={datePickerPosition(placement)}
        />
      )}
      {type === "date" && (
        <ReactDatePicker
          dateFormat="dd.MM.yyyy"
          placeholderText={placeholder}
          onChange={datepickerChange}
          minDate={datepickerMinDate()}
          maxDate={datepickerMaxDate()}
          selected={datepickerValue(value)}
          disabled={disabled}
          id={args.id ? args.id : null}
          locale={datepickerLanguage()}
          popperPlacement={datePickerPosition(placement)}
        />
      )}
      {type === "time" && (
        <ReactDatePicker
          selected={datepickerValue(value)}
          onChange={datepickerChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={1}
          timeCaption="Saat"
          dateFormat="HH:mm"
          id={args.id ? args.id : null}
          locale={datepickerLanguage()}
          popperPlacement={datePickerPosition(placement)}
        />
      )}
      {(type === "date" || type === "time" || type === "month") && value ? (
        <Icon name="x" size="16" onClick={removeDatePickerValue} />
      ) : null}
      {suffixIcon ? <Icon name={suffixIcon} size="16" /> : null}
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf([
    "tel",
    "text",
    "url",
    "email",
    "password",
    "number",
    "range",
    "date",
    "month",
    "time",
  ]),
  error: PropTypes.bool,
};
Input.defaultProps = {
  type: "text",
};
